import { t } from '../services/language-manager';

/** Coins glyph for an action type whose use is charged to the org. Decorative: the text says it. */
export function BilledIcon() {
  return (
    <svg
      className="billed-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="8" cy="8" r="6" />
      <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
      <path d="M7 6h1v4" />
      <path d="m16.71 13.88.7.71-2.82 2.82" />
    </svg>
  );
}

/**
 * Billed mark with its tooltip. By default not focusable: the control that owns
 * it points `aria-describedby` at `tooltipId` and shows the tooltip on keyboard
 * focus (see `.billed-mark__tooltip` in global.css), so Tab order is unchanged.
 * `focusable` is for static text with no owning control (the saved card's type
 * chip): the mark itself takes focus and carries the name and description.
 */
export function BilledMark({ tooltipId, focusable = false }: { tooltipId: string; focusable?: boolean }) {
  return (
    <span
      className="billed-mark"
      {...(focusable
        ? { tabIndex: 0, role: 'img', 'aria-label': t('settings-actions-billed-short'), 'aria-describedby': tooltipId }
        : {})}
    >
      <BilledIcon />
      <span className="billed-mark__tooltip" id={tooltipId} role="tooltip">
        {t('settings-actions-billed-tooltip')}
      </span>
    </span>
  );
}
